import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS, COMPLIANCE } from "../../data/content";
import { ShieldCheck } from "lucide-react";

export const TrustMarquee = () => {
  return (
    <section data-testid="trust-marquee" className="border-y border-border bg-card/40 py-8">
      <Marquee speed={38} gradient gradientColor="#0a0a0a" gradientWidth={120} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <div key={i} className="mx-8 flex items-center gap-8">
            <span className="font-heading text-2xl lg:text-3xl font-medium tracking-tight text-muted-foreground/70">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-primary/70" />
          </div>
        ))}
      </Marquee>

      <div className="mx-auto mt-8 flex max-w-[1400px] flex-wrap items-center justify-center gap-x-8 gap-y-3 px-6">
        {COMPLIANCE.map((c) => (
          <span
            key={c}
            className="inline-flex items-center gap-2 font-mono-ui text-[11px] uppercase tracking-[0.18em] text-muted-foreground"
          >
            <ShieldCheck size={14} strokeWidth={1.5} className="text-primary" />
            {c}
          </span>
        ))}
      </div>
    </section>
  );
};
